import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import { AppButton } from "@/shared/Components";
import { useVcf, VcfUploadWrapper } from "@/entities/vcf";
import { QuestionIcon } from "@/shared/icons";
import { useModal } from "@/features/modals/lib";
import { ModalVcfInfo } from "@/features/modals";
import styles from "./styles.module.scss";

export const ImportVcf = () => {
  const { hideModal, isModalOpen, showModal } = useModal();
  const { t } = useTranslation();
  const {
    methods: { handleUpload },
    state: { vcfIsLoading },
  } = useVcf();

  return (
    <>
      <div className={styles.root}>
        <div className={styles.spin}>{vcfIsLoading && <Spin />}</div>
        <VcfUploadWrapper beforeUpload={handleUpload} disabled={vcfIsLoading}>
          <AppButton disabled={vcfIsLoading} className={styles["import-button"]}>
            {t("contactsPage.importContacts")}
          </AppButton>
        </VcfUploadWrapper>
        <AppButton onClick={showModal} className={styles["question-button"]}>
          <QuestionIcon className={styles["icon"]} />
        </AppButton>
      </div>
      <ModalVcfInfo open={isModalOpen} onCancel={hideModal} onOk={hideModal} />
    </>
  );
};
